// @ts-nocheck
import interact from 'interactjs';
import type {LabelCtrlServ} from '../LabelCtrlServ';
import {Vertex2d} from './Vertex';

export default class ImageDragger {
    static isDragging = false;
    private interact: interact.Interactable;

    constructor(private labelCtrlServ: LabelCtrlServ, dragTarget: HTMLElement, useRightButton: boolean = false) {
        this.interact = interact(dragTarget, {}).draggable({
            restrict: {
                restriction: '.ai-common-image-loader-v3__drag_boundary',
            },
            onstart: this.dragStartListener.bind(this),
            onmove: this.dragMoveListener.bind(this),
            onend: this.dragEndListener.bind(this),
        })

        if (useRightButton) {
            this.interact = this.interact.actionChecker(function (pointer, event: interact.InteractEvent, action) {
                if(event.button === 0) {
                    return null;
                }
                if (event.button === 2) {
                    event.preventDefault();
                    return {name: 'drag', axis: 'xy'};
                }

                return action;
            })
        }


    }

    dragStartListener(event: interact.InteractEvent) {
        ImageDragger.isDragging = true;
        const target = event.target;
        target.setAttribute('unselectable', 'on');
    }

    dragMoveListener(event: interact.InteractEvent) {
        const deltaVertex2d = new Vertex2d(event.dx, event.dy)
        this.labelCtrlServ.ctrl_move_to(this.labelCtrlServ.userOffset.translate(deltaVertex2d))
        ImageDragger.isDragging = true;
    }

    clean() {
        this.interact.unset();
    }

    dragEndListener(event: interact.InteractEvent) {
        ImageDragger.isDragging = false;
        const target = event.target;
        target.removeAttribute('unselectable');
        event.stopImmediatePropagation();
    }
}
